import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const TagsInDiv = ({values = [], setValues}) => {
    const deleteTag = (e) => {
        let value = parseInt(e.currentTarget.dataset.id);
        let tags = values.filter(tag => tag.id !== value)
        setValues(tags)
    }

    return (
        <div className="tags-in-div form-control d-inline-flex flex-wrap disabled">
            {values.map((tag, index) => (
                <div className="tag-item badge bg-secondary bg-gradient me-1 my-1 py-auto pe-0"
                     key={index}
                >
                    {tag.name}
                    <button className="border-0 bg-transparent ms-3 me-1 my-auto py-auto px-0 text-white"
                            onClick={deleteTag} data-id={tag.id}>
                        <FontAwesomeIcon icon="xmark"/>
                    </button>
                </div>
            ))}
        </div>
    )

}
export default TagsInDiv;